module.exports = __webpack_public_path__ + "static/media/Group-2.92271f33.png";